import type { ToRefs, DeepReadonly } from 'vue'
import { reactive, watch, toRefs, readonly } from 'vue'

export type HoverStatusType = 'on' | 'off' | 'hold'

type State = {
  hoverStatus: HoverStatusType
}

type UseHoverable = ToRefs<DeepReadonly<State>> & {
  resetHoverStatus: () => void
  toggleHoverStatus: (isOpen: boolean) => void
}

export function useHoverable(element: Ref<{ $el: HTMLElement } | HTMLElement | null>): UseHoverable {
  const state = reactive<State>({ hoverStatus: 'off' })

  watch(element, el => {
    if (!el) return
    registerHoverEvents('$el' in el ? el.$el : el)
  })

  function registerHoverEvents(el: HTMLElement): void {
    el.addEventListener('mouseenter', () => {
      if (state.hoverStatus !== 'hold') {
        state.hoverStatus = 'on'
      }
    })

    el.addEventListener('mouseleave', () => {
      if (state.hoverStatus !== 'hold') {
        state.hoverStatus = 'off'
      }
    })
  }

  function resetHoverStatus(): void {
    Object.assign(state, { hoverStatus: 'off' })
  }

  function toggleHoverStatus(isOpen: boolean): void {
    Object.assign(state, { hoverStatus: isOpen ? 'hold' : 'off' })
  }

  return { ...toRefs(readonly(state)), resetHoverStatus, toggleHoverStatus }
}
